export function getMockedHaloEffects() {
    return [
        {
            id: -1,
            active: true,
            widgetType: 'halo-effect',
            startDateTime: '2022-04-13T11:59:58Z',
            endDateTime: null,
            ucpTargetings: [
                {
                    id: -1,
                    wikiId: null,
                    articleIds: [],
                    geos: [],
                    genres: [],
                    skins: [],
                    categories: [],
                    verticals: [],
                },
            ],
            states: [
                {
                    id: -1,
                    gridLayout: '3-column',
                    startDateTime: '2022-04-13T11:59:58Z',
                    clickThroughUrl: 'https://fandom.com',
                    pixel: 'https://static.wikia.nocookie.net/6a181c72-e8bf-419b-b4db-18fd56a0eb60',
                    label: 'Sponsored Halo Effect Label',
                    navCategories: ['anime', 'movies'],
                    images: [
                        {
                            id: -1,
                            url: 'https://script.wikia.nocookie.net/fandom-ae-assets/programmatic/widgets/halo-effect/test/spongebob_322_154.webp',
                            size: {
                                width: 322,
                                height: 154,
                            },
                        },
                    ],
                },
            ],
        },
    ];
}
